import styled, { css } from 'vue-styled-components';

import { FLEX_CENTER_DIV } from '@/styles/common.styled.component';
import { GRAY, BLUE, FLEX_CENTER, square } from '@styles/common.styled';

export const ComponentWrapper = styled('div', {
    width: [Number, String],
    isVisible: Boolean,
    appendToBody: Boolean,
    offSetTop: Number,
})`
    width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
    border: 1px solid ${GRAY(25)};
    background-color: #fff;
    display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
    z-index: 13;
    position: ${({ appendToBody }) => (appendToBody ? 'fixed' : 'absolute')};

    ${({ offSetTop = 0 }) =>
        offSetTop > 0 &&
        css`
            margin-top: ${offSetTop}px;
        `}
`;

export const OptionListWrapper = styled('div', {
    width: [Number, String],
    height: Number,
    hasBottomBorder: Boolean,
    hasSearchBar: Boolean,
    useVirtualScroll: Boolean,
})`
    position: relative;
    max-height: ${({ height }) => `${height}px`};
    @media screen and (max-height: 680px) {
        max-height: ${({ height }) => `${height / 2}px !important`};
    }

    border-top: ${({ hasSearchBar }) =>
        hasSearchBar ? `1px solid ${GRAY(25)}` : 'unset'};
    border-bottom: ${({ hasBottomBorder }) =>
        hasBottomBorder ? `1px solid ${GRAY(25)}` : 'unset'};

    ul {
        max-height: ${({ height }) => `${height}px`};
        @media screen and (max-height: 680px) {
            max-height: ${({ height }) => `${height / 2}px !important`};
        }

        overflow-y: ${({ useVirtualScroll }) =>
            useVirtualScroll ? 'hidden' : 'auto'};
        overflow-x: hidden;
        padding: 4px 0;

        &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${GRAY(25)};
            padding: 4px 8px;
        }

        .dropdown-virtual-scroller {
            overflow-y: auto;
            max-height: ${({ height }) => `${height}px`};
            @media screen and (max-height: 680px) {
                max-height: ${({ height }) => `${height / 2}px !important`};
            }

            &::-webkit-scrollbar {
                -webkit-appearance: none;
                width: 4px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: ${GRAY(25)};
                padding: 4px 8px;
            }
        }
    }
`;

export const OptionItem = styled('li', {
    isSelectedOption: Boolean,
    isBlocked: Boolean,
    tooltipOnEllipsis: Boolean,
})`
    color: ${({ isSelectedOption }) =>
        isSelectedOption ? BLUE(60) : GRAY(100)};
    font-weight: ${({ isSelectedOption }) =>
        isSelectedOption ? 600 : 'normal'};
    font-size: 13px;
    min-height: 36px;
    // height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 5px 15px;
    white-space: nowrap;
    ${({ isBlocked }) =>
        isBlocked &&
        css`
            opacity: 0.3;
            cursor: not-allowed;
        `}
    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    p {
        white-space: ${({ tooltipOnEllipsis }) =>
            tooltipOnEllipsis ? 'nowrap' : 'pre-line'};

        .item-img {
            margin-right: 8px;
            min-width: 16px;

            path {
                fill: ${({ isSelectedOption }) =>
                    isSelectedOption ? BLUE(60) : GRAY(80)};
            }
        }

        ${({ tooltipOnEllipsis }) =>
            tooltipOnEllipsis &&
            css`
                /* Fill the row like checkDropdown's block <p> so offsetWidth is a
                   stable box width (not fractional content width); otherwise a
                   sub-pixel scrollWidth diff falsely triggers the ellipsis tooltip. */
                flex: 1;
                min-width: 0;
                text-overflow: ellipsis;
                overflow: hidden;
            `}
    }

    &.selected {
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

export const CheckItemWrapper = styled.div`
    margin-left: 10px;
    ${FLEX_CENTER};

    .check-icon {
        ${square(16)}
        margin-right: 5px;
        fill: ${BLUE(60)};
    }
`;

export const LoaderWrapper = styled(FLEX_CENTER_DIV)`
    width: 100%;
    height: 200px;
    border-top: 1px solid ${GRAY(25)};
`;
